import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

interface SignStatus {
    configured: boolean;
    connected: boolean;
    connect_url: string;
    disconnect_url: string;
}

interface Provider {
    key: string;          // api/sign-integrations/<key>
    name: string;
    status: SignStatus;
    error: string;
}

/**
 * Settings > Integrations > E-Signature Providers (mockup settings #e-signatures: Adobe Sign and
 * DocuSign on one page): each provider's connection status with Connect (or Disconnect) through
 * the existing Laravel start URLs. A tenant without the keys set up is told to contact the system
 * administrator. The old /settings/adobe-sign and /settings/docusign URLs open this page.
 */
@Component({
    selector: 'app-sign-integration',
    templateUrl: './sign-integration.component.html',
    styleUrls: ['./sign-integration.component.scss']
})
export class SignIntegrationComponent implements OnInit {
    readonly providers: Provider[] = [
        { key: 'adobe-sign', name: 'Adobe Sign', status: null, error: '' },
        { key: 'docusign', name: 'DocuSign', status: null, error: '' },
    ];

    constructor(private http: HttpClient) { }

    ngOnInit() {
        this.providers.forEach(provider => this.http.get<SignStatus>(environment.api + 'sign-integrations/' + provider.key).subscribe(
            res => provider.status = res,
            err => provider.error = typeof err === 'string' ? err : 'The connection status could not be loaded.'
        ));
    }
}
